// Animations Component
export function initAnimations() {
  const animations = {
    init() {
      console.log("🎬 Animations init started");
      this.initIntersectionObserver();
      this.initScrollAnimations();
      this.initCounters();
      this.initBackToTop();
    },

    initIntersectionObserver() {
      const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-fade-in-up');
            observer.unobserve(entry.target);
          }
        });
      }, observerOptions);

      // Observe elements with animation classes
      document.querySelectorAll('.animate-on-scroll').forEach(el => {
        observer.observe(el);
      });
    },

    initScrollAnimations() {
      // Fade in animations for elements with animate-fade-in class
      const fadeElements = document.querySelectorAll('.animate-fade-in, .fade-in-up, .scale-in');
      
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      }, { 
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      });

      fadeElements.forEach(el => {
        // Add initial state
        if (!el.classList.contains('visible')) {
          el.style.opacity = '0';
          el.style.transform = 'translateY(30px)';
          el.style.transition = 'all 0.6s ease-out';
        }
        observer.observe(el);
      });
      
      // Add CSS for visible state
      if (!document.getElementById('animation-styles')) {
        const style = document.createElement('style');
        style.id = 'animation-styles';
        style.textContent = `
          .fade-in-up.visible,
          .animate-fade-in.visible,
          .scale-in.visible {
            opacity: 1 !important;
            transform: translateY(0) scale(1) !important;
          }
        `;
        document.head.appendChild(style);
      }
    },

    initCounters() {
      const counters = document.querySelectorAll('[data-counter]');
      
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.animateCounter(entry.target);
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.5 });

      counters.forEach(counter => observer.observe(counter));
    },

    animateCounter(element) {
      const target = parseInt(element.getAttribute('data-counter'));
      const duration = 2000;
      const step = target / (duration / 16);
      let current = 0;

      const timer = setInterval(() => {
        current += step;
        if (current >= target) {
          current = target;
          clearInterval(timer);
        }
        element.textContent = Math.floor(current);
      }, 16);
    },

    initBackToTop() {
      const backToTopButton = document.getElementById('back-to-top');
      if (!backToTopButton) return;

      window.addEventListener('scroll', () => {
        if (window.pageYOffset > 300) {
          backToTopButton.classList.remove('opacity-0', 'invisible');
          backToTopButton.classList.add('opacity-100', 'visible');
        } else {
          backToTopButton.classList.add('opacity-0', 'invisible');
          backToTopButton.classList.remove('opacity-100', 'visible');
        }
      });

      backToTopButton.addEventListener('click', () => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      });
    },

    // Utility function for scroll-triggered animations
    onScroll(callback, throttleMs = 10) {
      let ticking = false;
      
      function update() {
        callback();
        ticking = false;
      }
      
      function requestTick() {
        if (!ticking) {
          requestAnimationFrame(update);
          ticking = true;
        }
      }
      
      window.addEventListener('scroll', requestTick);
    }
  };

  // Initialize when called
  animations.init();
}
